import React from "react";

export default function Offline({ setStatus }) {
  return (
    <div className="w-full h-screen bg-color-primary-B flex flex-col items-center justify-center text-[#000000] font-font_primary_A ">
      <svg
        className="wifi-svg"
        viewBox="0 0 100 100"
        width="100px"
        height="100px"
        stroke="#153038"
        strokeWidth="5"
        // fill="white"
        strokeLinecap="butt"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle id="wifi-0" cx="50" cy="80" r="5" strokeWidth="0" />

        <path
          id="wifi-1"
          d="
          M 35 70
          Q 50 60, 65 70
        "
          fill="none"
        />
        <path
          id="wifi-2"
          d="
          M 25 60
          Q 50 40, 75 60
        "
          fill="none"
        />
        <path
          id="wifi-3"
          d="
          M 15 50
          Q 50 20, 85 50
        "
          fill="none"
        />
        <path
          id="wifi-4"
          d="
          M 5 40
          Q 50 0, 95 40
        "
          fill="none"
        />
        <path
          id="wifi-none"
          d="
          M 5 40
          Q 50 0, 95 40
          L 50 82.5
          Z
        "
          fill="none"
          stroke="none"
        />
      </svg>

      <p className="text-[6vw] font-font_primary_A font-bold text-[#153038] mt-[7.4vw]">
        ارتباط برقرار نشد
      </p>
      <p className="text-[4vw] font-font_primary_A  text-[#474747] flex items-center justify-center mt-[1vw]">
        از وصل بودن اینترنت مطمئن شوید
      </p>
      <button
        className="w-[45vw] font-font_primary_A  bg-[#fff] text-[4vw] text-[#153038] py-[0.5vw] px-[2vw] rounded-[1.8vw] mt-[7.4vw]"
        onClick={() => {
          window.ononline = (e) => {
            setStatus(true);
          };
          window.onoffline = (e) => {
            setStatus(false);
          };
        }}
      >
        تلاش مجدد
      </button>
    </div>
  );
}
